module.exports = __webpack_public_path__ + "media/trail/icons-controls-3d-f33332b7.svg";